import PropTypes from "prop-types"
import { selectAuth } from "./slice"
import { useSelector } from "react-redux"
import { hasAny } from "./roles"

/** Authed only renders its children if the current user has at least
 * one of `allowRoles` (regardless of context).
 */
const Authed = ({ children, allowRoles }) => {
  // Get auth / roles
  const auth = useSelector(selectAuth)
  if (!hasAny(auth?.roles, allowRoles)) {
    return null
  }
  // If roles includes required roles, render children
  return children
}

Authed.propTypes = {
  children: PropTypes.any,
  allowRoles: PropTypes.array,
}

export default Authed
